<template lang="pug">
  .crud
    modal-import(model="sales" :title="$t('front.import_modal', {model: $t('strings.sales')})")
    modal-sales(:form='form', :is-add='isModalAdd')
    modal-sales-invoices(:sale="sale")
    modal-sales-payment-date(:id="currentId" :action="currentAction")
    modal-attachmentss(:sale_id='sale_id')
    modal-comments(:newRecord='newRecord')
    modal-packing(:id="currentId")
    modal-tag(:id="currentId")
    modal-sale-tracings(:sale_id="currentId")
    modal-customer-sales
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.sales') }}:
            span {{ $t('strings.description', {attribute: $t('strings.sales')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-button(icon="plus" @click="addSale" style="display: none;") {{ $t('strings.add') }}
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin')" @click="printReport")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print_pdf') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin')" @click="printReportCsv")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print_csv') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin')" @click="setModalCustomerSalesVisible(true)")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.customer_sales_report') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin')" @click="deleteSalesConfirm" :disabled="!enabledDelete")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="setModalImportVisible(true)")
                    vm-icon(icon="upload-outline")
                    slot &nbsp;{{ $t('strings.import') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="printInvoices")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('sales.print_invoices') }}
                  //- More options
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(multiple v-model="selected"  max-height="350px" :data="sales")
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(icon="search" size="small" :placeholder="$t('strings.search')" v-model="filters.where.param" @keyup.enter="applyFilter(filters)")
                div
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")

                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                        vm-date-picker.filter(type="daterange" :label="$t('sales.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                        vm-date-picker.filter(type="daterange" :label="$t('sales.liquidation_date')" :placeholder="$t('strings.select_date')" @on-change="handleChangeL" :value="filters.betweenDates.liquidation_date")
                        vm-date-picker.filter(type="daterange" :label="$t('sales.delivery_date')" :placeholder="$t('strings.select_date')" @on-change="handleChangeD" :value="filters.betweenDates.delivery_date")
                        vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                          vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                        vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('sales.delivery_status')" v-model="filters.whereIn.delivery_status")
                          vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in delivery_status")
                        vm-select.filter(url="customers" column="tradename" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('sales.customer_id')" v-model="filters.whereIn.customer_id" @input-change="autoCompleteFunc")
                          vm-select-item(:key="index" :value="item.id" :text="item.tradename" v-for="(item,index) in salesCatalog.customers")
                        vm-select.filter(url="users" column="name" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('sales.seller_id')" v-model="filters.whereIn.created_by_id" @input-change="autoCompleteFunc")
                          vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in salesCatalog.users")
                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                  vm-select(:placeholder="$t('strings.order_by')" autocomplete v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px")
                    div(v-for="(item,index) in columns")
                      vm-select-item(:key="item + ',asc'" v-if="item !== ''" :value="item + ',asc'" :text="$t('sales.'+ item) + ', asc'")
                      vm-select-item(:key="item + ',desc'" v-if="item !== ''" :value="item + ',desc'" :text="$t('sales.'+ item) + ', desc'")
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list" style="display: none;")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('sales.' + column) }}
              vm-th
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
                  .row(@click="showSalesDetail(data[indextr])")
                    slot(v-if="column === 'no'") {{data[indextr]['id'] }}
                    slot(v-if="column == 'created_at_oc' && data[indextr]['purchase_orders'].length > 0") {{data[indextr]['purchase_orders'][0]['created_at'] | moment('DD-MMMM-YYYY')}}
                    slot(v-if="column == 'total_mn' || column == 'unit_price' || column == 'total'")  {{data[indextr][column] | currency }}
                    slot(v-if="column != 'status' && column != 'total_mn' && column != 'total' && column != 'cost' && column != 'unit_price' && column != 'customer_id' && column != 'created_by_id' && column != 'currency_id' && column !== 'attachments' && column !== 'order_customer' && column != 'utility_percent' && column != 'invoice' && column != 'liquidation_date' && column != 'delivery_status' && column != 'delivery_date'") {{data[indextr][column] }}
                    slot(v-if="column == 'customer_id'") {{data[indextr]['customer']['tradename'] }}
                    slot(v-if="column == 'supplier'")
                      div.scrollable
                        span(v-if="data[indextr]['supplier_quotation'].length > 0") {{ data[indextr]['supplier_quotation'][0].supplier.name | truncate }}
                        span(v-if="data[indextr]['supplier_quotation'].length > 1" class="check" style="background-color: rgb(255, 130, 0);")
                        span(v-if="data[indextr]['supplier_quotation'].length == 1" class="check" style="background-color: rgb(23, 201, 100);")
                    slot(v-if="column == 'invoice'")
                      div.scrollable
                        span(v-if="data[indextr]['invoices'].length > 0") {{ data[indextr]['invoices'][0].invoice_number }}
                        span(v-if="data[indextr]['invoices'].length > 1" class="check" style="background-color: rgb(255, 130, 0);")
                        span(v-if="data[indextr]['invoices'].length == 1" class="check" style="background-color: rgb(23, 201, 100);")
                    slot(v-if="column == 'order_customer'") {{data[indextr]['quotation']['order_customer'] }}
                    slot(v-if="column == 'flete'") {{data[indextr]['flete_display'] | currency }}
                    slot(v-if="column == 'subtotal'") {{data[indextr]['quotation']['subtotal'] | currency }}
                    slot(v-if="column == 'cost'") {{data[indextr]['cost'] | currency }}
                    slot(v-if="column == 'utility'") {{data[indextr]['money_utility'] | currency }}
                    slot(v-if="column == 'utility_percent'") {{parseFloat(data[indextr]['utility_percent']).toFixed(2)}}%
                    vm-icon(size='small' v-if="column == 'utility_percent' && data[indextr]['utility_percent'] > 0" icon='trending-up-outline' color='success')
                    vm-icon(size='small' v-if="column == 'utility_percent' && data[indextr]['utility_percent'] < 0" icon='trending-down-outline' color='danger')
                    slot(v-if="column == 'created_by_id'") {{data[indextr]['created_by'] ? data[indextr]['created_by']['name'] : ''}}
                    slot(v-if="column == 'currency_id'") {{data[indextr]['currency']['code']}}
                    slot(v-if="column == 'liquidation_date' && data[indextr]['liquidation_date'] != null") {{ data[indextr]['liquidation_date'] | moment('DD-MMMM-YYYY') }}
                    slot(v-if="column == 'delivery_date' && data[indextr]['delivery_date'] != null") {{ data[indextr]['delivery_date'] | moment('DD-MMMM-YYYY') }}
                    vm-button.print(v-if="column == 'attachments'" type="flat" icon="folder-outline" :color="attaStatus(data[indextr]['attachments'])" @click="attachments(data[indextr], tr)")
                    vm-chip(v-if="column == 'status'" :color="colorStatus(data[indextr][column])") {{data[indextr]['status_display']}}
                    vm-chip(v-if="column == 'delivery_status' && data[indextr][column]" :color="deliveryStatus(data[indextr][column])") {{data[indextr]['status_display_delivery']}}
                vm-td
                  vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] != '3'" @click="editSale(data[indextr], tr)")
                        vm-icon(icon="edit-2-outline")
                        slot &nbsp;{{ $t('strings.edit') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="attachments(data[indextr], tr)")
                        vm-icon(icon="folder-outline")
                        slot &nbsp;{{ $t('sales.attachments') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="viewInvoices(data[indextr])" v-if="$auth.check('Admin')")
                        vm-icon(icon="plus-square-outline")
                        slot &nbsp;{{ $t('strings.invoices') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="goToSendingReceptions(data[indextr])")
                        vm-icon(icon="car-outline")
                        slot &nbsp;{{ $t('strings.sendings') }}
                      vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] != '3' && $auth.check('Admin')" @click="deleteSaleConfirm(data[indextr])")
                        vm-icon(icon="trash-2-outline")
                        slot &nbsp;{{ $t('strings.delete') }}
                      vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == '3'" @click="editSale(data[indextr])")
                        vm-icon(icon="eye-outline")
                        slot &nbsp;{{ $t('strings.view') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="printPacking(data[indextr])")
                        vm-icon(icon="printer-outline")
                        slot &nbsp;{{ $t('strings.packing_list') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="printTag(data[indextr])")
                        vm-icon(icon="printer-outline")
                        slot &nbsp;{{ $t('strings.tag') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="seeComments(data[indextr], tr)")
                        vm-icon(icon="eye-outline")
                        slot &nbsp;{{ $t('strings.see_comments') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="tracings(data[indextr])")
                        vm-icon(icon="file-text-outline")
                        slot &nbsp;{{ $t('strings.sale_tracings') }}
                    //- More actions
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ModalSales from '@/components/modals/ModalSales.vue'
import ModalSalesInvoices from '@/components/modals/ModalSalesInvoices.vue'
import ModalSalesPaymentDate from '@/components/modals/ModalSalesPaymentDate.vue'
import ModalImport from '@/components/modals/ModalImport.vue'
import ModalAttachmentss from '@/components/modals/ModalAttachmentss.vue'
import ModalComments from '@/components/modals/ModalComments.vue'
import ModalPacking from '@/components/modals/ModalPacking.vue'
import ModalTag from '@/components/modals/ModalTag.vue'
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import ModalSendingReceptions from '@/components/modals/ModalSendingReceptions.vue'
import ModalSaleTracings from '@/components/modals/ModalSaleTracings.vue'
import ModalCustomerSales from '@/components/modals/ModalCustomerSales.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Sales')

export default {
  name: 'Sales',
  components: {
    ModalSales,
    ModalImport,
    ModalSalesInvoices,
    ModalSalesPaymentDate,
    ModalAttachmentss,
    ModalComments,
    ModalPacking,
    ModalTag,
    ModalSendingReceptions,
    ModalSaleTracings,
    ModalCustomerSales
  },
  data: () => ({
    sale: {},
    currentPage: 1,
    currentAmount: '',
    isModalAdd: true,
    isModalAddInvoiceNumber: true,
    form: {},
    newRecord: {},
    quotation_id: '',
    currency_code: 'MNX',
    currentId: 0,
    sale_id: null,
    currentAction: '',
    selected: [],
    formInvoice: {},
    enabledDelete: false,
    columns: [
      'folio',
      'created_at_oc',
      'order_customer',
      'customer_id',
      'supplier',
      'quotation_folio',
      'invoice',
      'cost',
      'flete',
      'subtotal',
      'total',
      'utility',
      'utility_percent',
      'currency_id',
      'status',
      'delivery_status',
      'delivery_date',
      'liquidation_date',
      'created_by_id'
    ],
    status: [
      {
        text: 'Vendido',
        value: 1,
        color: 'primary'
      },
      {
        text: 'Facturado',
        value: 2,
        color: 'warning'
      },
      {
        text: 'Pagado',
        value: 3,
        color: 'success'
      },
      {
        text: 'Pagado parcialmente',
        value: 4,
        color: '#FFD000'
      },
      {
        text: 'facturado parcialmente',
        value: 5,
        color: '#FFD000'
      }
    ],
    delivery_status: [
      {
        text: 'A tiempo',
        value: 6,
        color: 'primary'
      },
      {
        text: 'A punto de vencer',
        value: 7,
        color: 'warning'
      },
      {
        text: 'Vencida',
        value: 8,
        color: 'danger'
      },
      {
        text: 'Envio Completado',
        value: 9,
        color: 'success'
      },
      {
        text: 'Envio Parcial',
        value: 10,
        color: 'warning'
      }
    ],
    filters: {
      where: {
        folio: '',
        quotation: {
          order_customer: '',
          folio: ''
        },
        invoices: {
          invoice_number: ''
        },
        customer: {
          tradename: ''
        },
        param: ''
      },
      whereIn: {
        customer_id: [],
        created_by_id: [],
        status: [],
        delivery_status: []
      },
      whereBetween: {
        total: []
      },
      betweenDates: {
        created_at: [],
        liquidation_date: [],
        delivery_date: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  computed: {
    ...mapGetters(['sales', 'salesCatalog', 'pagination', 'filterParams']),
    total () {
      return this.selected
        .reduce((prev, cur) => prev + parseFloat(cur.total_mn), 0)
        .toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getSales(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 &&
        (this.filters = parseVuexObject(this.filtersClear))
      this.currentPage = 1
      this.selected = []
      this.getSales(this.currentPage)
    },
    selected (selected) {
      this.enabledDelete = selected.length > 0
    }
  },
  async created () {
    this.filtersClear = parseVuexObject(this.filters)
    this.currentPage = this.pagination.currentPage
      ? this.pagination.currentPage
      : 1
    await this.getSales(this.currentPage)
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'deleteSale',
      'deleteSales',
      'loadSales',
      'loadSale',
      'loadCatalog',
      'actionSale',
      'setModalImportVisible',
      'setModalInvoicesVisible',
      'setModalPaymentDateVisible',
      'setModalVisible',
      'setModalAttachmentVisible',
      'setModalCommentsVisible',
      'setModalPackingVisible',
      'setModalTagVisible',
      'setModalTracingsVisible',
      'setModalCustomerSalesVisible',
      'printReport',
      'printReportCsv',
      'printInvoices',
      'applyFilter',
      'clearFilter'
    ]),
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code)).color
    },
    attaStatus (code) {
      return code.length > 0 ? 'primary' : '#afbbc6'
    },
    deliveryStatus (code) {
      return this.delivery_status.find(e => e.value === parseInt(code)).color
    },
    viewInvoices (record) {
      this.sale = record
      this.setModalInvoicesVisible(true)
    },
    setInvoiceStatus (record, action) {
      this.actionSale({ id: record.id, action: action })
      this.invoiceNumber = ''
    },
    setPaymentDate (record, action) {
      this.currentId = record.id
      this.currentAction = action
      this.setModalPaymentDateVisible(true)
    },
    goToSendingReceptions (record) {
      this.$router.push({
        name: 'saleSendingReceptions',
        params: { id: record.id }
      })
    },
    addSale () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.form = {}
    },
    editSale (sale, index) {
      this.isModalAdd = false
      this.setModalVisible(true)
      this.form = { ...sale }
    },
    async deleteSaleConfirm (sale) {
      let t = this
      this.auxDeleteSale = () => {
        t.deleteSale(sale).then(() => {
          t.selected = []
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', {
          model: this.$t('strings.sale'),
          attribute: this.$t(sale.id)
        }),
        accept: this.auxDeleteSale
      })
    },
    async deleteSalesConfirm () {
      let t = this
      let salesMany = parseDeleteMany(this.selected, 'id')
      this.auxDeleteSale = () => {
        t.deleteSales(salesMany).then(() => {
          t.selected = []
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', {
          model: this.$t('strings.sale'),
          attribute: salesMany.values
        }),
        accept: this.auxDeleteSale
      })
    },
    async setActionSale (record, action) {
      record.id && this.actionSale({ id: record.id, action })
    },
    async getSales (page) {
      let t = this
      this.loadSales({ page }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let sale = this.sales.filter(sale => sale.id === parseInt(index))[0]
      sale && this.editSale(sale, index)
    },
    async getCatalog () {
      Object.keys(this.salesCatalog).forEach(e =>
        this.loadCatalog({ url: e, filter: '' })
      )
    },
    attachments (sale) {
      this.setModalAttachmentVisible(true)
      this.sale_id = sale.id
      this.loadSale(sale)
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute(
        'column'
      )
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute(
        'url'
      )
      payload.filter = `?${column}=*${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      this.filters.betweenDates.created_at = date
    },
    handleChangeL (date) {
      this.filters.betweenDates.liquidation_date = date
    },
    handleChangeD (date) {
      this.filters.betweenDates.delivery_date = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter(item => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    },
    seeComments (purchaseOrder, index) {
      this.setModalCommentsVisible(true)
      this.newRecord = { ...purchaseOrder }
    },
    printPacking (record) {
      this.currentId = record.id
      this.setModalPackingVisible(true)
    },
    printTag (record) {
      this.currentId = record.id
      this.setModalTagVisible(true)
    },
    tracings (record) {
      this.currentId = record.id
      this.setModalTracingsVisible(true)
    },
    showSalesDetail (sales) {
      let id = sales.id
      this.$router.push({ name: 'salesDetailsShow', params: { id } })
    }
  }
}
</script>

<style lang="scss">
.scrollable {
  position: relative;
}

.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.check {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  position: absolute;
  top: calc(50% - 5px);
  right: 0;
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
.vm-chip-success {
  background: rgba(var(--success), 1) !important;
}
.vm-chip-primary {
  background: rgba(var(--primary), 1) !important;
}
.vm-chip-warning {
  background: rgba(var(--warning), 1) !important;
}
.vm-table--thead-table th {
  white-space: nowrap;
}
</style>
